import { useRecoilState } from "recoil";
import { toastMessage } from "../../store/layout";
import { ToastMessage } from "@lyfegen-platform/react-common";
import { useEffect, useState } from "react";

export default function LayoutToastMessage() {
	const [toastMessageAlert, setToastMessageAlert] = useRecoilState(toastMessage);
	const [alertMessage, setAlertMessage] = useState<string | null>(null);

	const closeAlert = () => {
		setAlertMessage(null);
		setToastMessageAlert({ message: null });
	};

	useEffect(() => {
		if (toastMessageAlert.message) {
			setAlertMessage(toastMessageAlert.message);
		}
	}, [toastMessageAlert.message]);

	return (
		<div>
			<ToastMessage
				isOpen={!!alertMessage}
				variant="dark"
				onClose={closeAlert}
				onAlertClose={closeAlert}
				message={alertMessage || ""}
			/>
		</div>
	);
}
